var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 259,
    viewBox: "0 0 255 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26208 111.072C8.50208 78.602 27.0221 50.502 54.4021 31.962C81.7821 13.422 114.742 6.64198 147.212 12.892C179.682 19.132 207.782 37.652 226.322 65.032C244.862 92.412 251.642 125.372 245.392 157.842C239.152 190.312 220.632 218.412 193.252 236.952C165.872 255.492 132.912 262.272 100.442 256.022C67.9721 249.782 39.8721 231.262 21.3321 203.882C2.79207 176.502 -3.97792 143.542 2.26208 111.072ZM243.732 157.512C256.452 91.392 213.002 27.262 146.892 14.552C80.7721 1.83198 16.6421 45.272 3.93208 111.392C-8.78792 177.512 34.6621 241.642 100.772 254.352C166.892 267.072 231.022 223.622 243.732 157.512Z",
    fill: "url(#paint0_linear_6_473)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30204 100.452C8.54204 67.9819 27.062 39.8819 54.442 21.3419C81.812 2.79193 114.772 -3.97807 147.242 2.26193C179.712 8.50193 207.812 27.0219 226.352 54.4019C244.892 81.7819 251.672 114.742 245.422 147.212C239.182 179.682 220.662 207.782 193.282 226.322C165.902 244.862 132.942 251.642 100.472 245.392C68.002 239.152 39.902 220.632 21.362 193.252C2.83204 165.882 -3.94796 132.922 2.30204 100.452ZM243.772 146.892C256.492 80.7719 213.042 16.6419 146.932 3.93193C80.812 -8.78807 16.672 34.6519 3.96204 100.772C-8.75796 166.892 34.692 231.022 100.802 243.732C166.922 256.452 231.052 213.002 243.762 146.892H243.772Z",
    fill: "url(#paint1_linear_6_473)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2821 102.942C15.5221 70.4719 34.0421 42.3719 61.4221 23.8319C88.8021 5.29185 121.762 -1.48814 154.232 4.76186C186.702 11.0019 214.802 29.5219 233.342 56.9019C251.882 84.2819 258.662 117.242 252.412 149.712C246.172 182.182 227.652 210.282 200.272 228.822C172.892 247.362 139.932 254.142 107.462 247.892C74.9921 241.652 46.8921 223.132 28.3521 195.752C9.8121 168.372 3.0421 135.412 9.2821 102.942ZM250.752 149.382C263.472 83.2619 220.022 19.1319 153.912 6.42186C87.7921 -6.29814 23.6621 37.1519 10.9421 103.262C-1.76791 169.382 41.6721 233.512 107.792 246.232C173.912 258.952 238.042 215.502 250.752 149.392V149.382Z",
    fill: "url(#paint2_linear_6_473)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_473",
    x1: 217.446,
    y1: 215.507,
    x2: 30.1974,
    y2: 53.3607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00FB0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00F329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00E852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#00FFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_473",
    x1: 217.482,
    y1: 204.892,
    x2: 30.2333,
    y2: 42.7464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00FB0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00F329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00E852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#00FFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_473",
    x1: 224.467,
    y1: 207.387,
    x2: 37.2179,
    y2: 45.2407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00FB0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00F329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00E852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#00FFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/Logo2.8fd2cef7714ee54fd5abceb380625c85.svg";
export { ForwardRef as ReactComponent };